module.exports = __webpack_public_path__ + "img/skyadminka.ff8c75fd.png";